import { Injectable } from '@angular/core';
import { Colour } from '../interfaces/colour';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ColourCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/colours/' ;
  }

  // Create Colour
  add(record: Colour) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Colour Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Colours List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Colour Object
  update(record: Colour) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Colour>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Colour Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
